import { Component, Input, OnChanges } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { NgClass } from '@angular/common';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

@Component({
  selector: 'concept-steps',
  templateUrl: './concept-steps.component.html',
  standalone: true,
  imports: [
    NgClass,
    TooltipModule
  ]
})
export class ConceptStepsComponent implements OnChanges {
  custom: any = this.customLanding.getCustom();
  isLanding: boolean = this.customLanding.isLanding();
  conceptSteps: any = {
    initialStep: 0,
    filterContainers: []
  }
  constructor( private customLanding: CustomLandingFactory ) { }

  @Input() concept: any = null;
  @Input() filterContainers: any = null;
  @Input() changeStepsConcept: any = null;

  ngOnChanges() {
    let that: any = this.conceptSteps;
    if (this.concept?.conceptNamedKey === 'Cliente') {
      let idVersionGroup = sessionStorage.getItem('idVersionGroup');
      that.initialStep = idVersionGroup ? this.getGroup(parseInt(idVersionGroup)) : 1;
    } else {
      that.initialStep = 1;
      sessionStorage.removeItem('idVersionGroup');
    }
    this.configureStepsArray();
    switch (this.changeStepsConcept?.action) {
      case 'configureSteps':
        this.configureSteps();
        break;
      case 'changeEvaluatedConcept':
        this.configureActualStep();
        break;
      case 'changeStep':
        this.changeStep(this.changeStepsConcept.step);
        break;
    }
  }

  private getGroup(idVersionGroup: any) {
    for (let i = 0; i < this.filterContainers.length; i++) {
      let group = this.filterContainers[i];
      if (group.fieldContainerId === idVersionGroup) {
        sessionStorage.removeItem('idVersionGroup');
        return group.index ? group.index : i + 1;
      }
    }
  }

  private configureStepsArray() {
    this.conceptSteps.filterContainers = [];
    this.filterContainers.forEach((fieldContainer: any, index: any) => {
      if (fieldContainer.show && !fieldContainer.hidden && fieldContainer.showWithProperty && !(this.isLanding && fieldContainer.hiddenInLandings)) {
        fieldContainer.index = this.conceptSteps.filterContainers.length + 1;
        this.conceptSteps.filterContainers.push(fieldContainer);
      }
    });
  }

  private configureSteps() {
    if (this.filterContainers.length > 1) {
      let step: number = this.conceptSteps.initialStep;
      if (this.concept.actualStep && this.concept.actualStep > 1) {
        step = this.concept.actualStep;
      }
      this.changeStep(step);
    } else {
      this.concept.actualStep = 1;
    }
  }

  private changeStep(step: any) {
    let filteredSteps: any = [];
    for (let i = 0; i < this.filterContainers.length; i++) {
      this.filterContainers[i].active = false;
      if (!this.filterContainers[i].index) {
        this.getIndexShow(this.filterContainers[i], filteredSteps);
      }
      if (step === this.filterContainers[i].index) {
        this.filterContainers[i].active = true;
      }
    }
    this.concept.actualStep = step;
    this.concept.actualStepIsLast = this.getLastStep(step);
    let fieldsBlock: any = $('.concept-form__fields-block');
    let evaluation: any = $('#centinela-app-template');
    if (this.changeStepsConcept?.action === 'changeStep' && fieldsBlock.height() > evaluation.scrollTop()) {
      evaluation.scrollTop(0);
    }
  }

  private getIndexShow(item: any, filtered: any) {
    if (item.show && !item.hidden && item.showWithProperty) {
      item.index = filtered.length + 1;
      filtered.push(item);
    } else {
      delete item.index;
    }
  }

  private getLastStep(actualStep: any) {
    let containersShow = 0;
    for (const group of this.filterContainers) {
      if (group.show && !group.hidden && group.showWithProperty) {
        containersShow++;
      }
    }
    return containersShow === actualStep ? true : false;
  }

  private configureActualStep() {
    for (let i = 0; i < this.filterContainers.length; i++) {
      let group = this.filterContainers[i];
      if (group.active) {
        if (group.index !== this.concept.actualStep) {
          this.changeStep(group.index);
        } else {
          this.concept.actualStepIsLast = this.getLastStep(group.index);
        }
        break;
      }
    }
  }

  selectStep(fieldContainer: any) {
    this.changeStep(fieldContainer.index);
  }
}
